/**
 * Constants common to several parts of the console
 */

export const DRIVER = "DRIVER";
export const TRUCK = "TRUCK";
export const TRAILER = "TRAILER";

export const human = "human";
export const driver = "driver";
export const passenger = "passenger";
export const truck = "truck";
export const trailer = "trailer";
export const trailer1 = "trailer1";
export const trailer2 = "trailer2";
export const container = "container";
export const container1 = "container1";
export const container2 = "container2";
export const vehicle = "vehicle";
export const car = "car";
export const railcars = "railcars";

export const detected = "detected";
export const absent = "absent";
export const identified = "identified";
export const unidentified = "unidentified";
export const supplemental = "supplemental";
export const thermal = "thermal";
export const state_reset = "reset";

export const CONTEXT = "CONTEXT";
export const CONTEXT_LPR = "CONTEXT_LPR";
export const CONTEXT_OCR = "CONTEXT_OCR";
export const OCR = "OCR";
export const LPR = "LPR";
export const FACE_DETECT = "FACE_DETECT";
export const HUMAN_DETECT = "HUMAN_DETECT";
export const HUMAN_EXIT = "HUMAN_EXIT";

export const AWS = "AWS";
export const MS = "MS";
export const FR = "FR";
export const LUKE = "LUKE";

export const MDC = "MDC";
export const HSP = "HSP";
export const MSP = "MSP";
export const IDP = "IDP";
export const WMS = "WMS";
export const VMI = "VMI";
export const TVS = "TVS";

export const LANGUAGES = ["en", "fr"];

// Data Types
export const date = "date";
export const select = "select";

// Dashboard
export const activeCases = "activeCases";
export const failedSurveys = "failedSurveys";
export const feverdetected = "feverdetected";

// Status
export const loading = "loading";
export const error = "error";
export const success = "success";

// Events
export const eventGroups = "eventGroups";
export const allEvents = "allEvents";

export const vmirequests = "requests";
export const vmiorders = "orders";

// Temperature
export const ISO_TYPE = "iso";
export const BODY_TYPE = "body";
export const MANUAL_TYPE = "manual";

// Sizes
export const sizes = {
  xsmall: "xsmall",
  smal: "small",
  medium: "medium",
  large: "large",
  xlarge: "xlarge",
};

export const entrances = "entrances";
export const exits = "exits";

// Log Details
export const logDetailsTabs = {
  summary: "summary",
  human: "human",
  vehicle: "vehicle",
  trailer: "trailer",
  verification: "verification",
  notes: "notes",
  temperature: "temperature",
};

// Policies statuses
export const ok = "ok";
export const warning = "warning";
export const denied = "denied";

// Temperatures
export const CELSIUS_THRESHOLD = 37.7;
export const FAHRENHEIT_THRESHOLD = 99.86;

// Calendar views
export const calendarViews = {
  daily: "day",
  weekly: "week",
};

export const postDbDateFormat = "YYYY-MM-DD[T]HH:mm:ss.SS[Z]";
